export const snapToInterval = (
  num: number,
  step: number,
  direction: 'up' | 'down',
  minRate: number,
  maxRate: number
): number => {
  const isAtInterval = num * 2 === Math.floor(num * 2);

  if (direction === 'up') {
    return Math.min(
      isAtInterval ? num + step : Math.ceil(num * 2) / 2,
      maxRate
    );
  }

  return Math.max(
    isAtInterval ? num - step : Math.floor(num * 2) / 2,
    minRate
  );
};

export const validateInput = (inputValue: string): boolean => {
  if (inputValue === '') {
    return false;
  }

  const normalized = inputValue.replace(',', '.');

  const regex = /^\d*\.?\d*$/;
  if (!regex.test(normalized)) {
    return false;
  }

  const numValue = parseFloat(normalized);
  return !isNaN(numValue);
};
